const translations = {
    fr: {
        veryWeak: "Très faible",
        weak: "Faible",
        medium: "Moyen",
        strong: "Fort",
        veryStrong: "Très fort",
    },
    en: {
        veryWeak: "Very weak",
        weak: "Weak",
        medium: "Medium",
        strong: "Strong",
        veryStrong: "Very strong",
    },
    de: {
        veryWeak: "Sehr schwach",
        weak: "Schwach",
        medium: "Mittel",
        strong: "Stark",
        veryStrong: "Sehr stark",
    },
    es: {
        veryWeak: "Muy débil",
        weak: "Débil",
        medium: "Medio",
        strong: "Fuerte",
        veryStrong: "Muy fuerte",
    },
    it: {
        veryWeak: "Molto debole",
        weak: "Debole",
        medium: "Medio",
        strong: "Forte",
        veryStrong: "Molto forte",
    },
};

export default translations;